module.exports = __webpack_public_path__ + "img/3-4.f7f3fda6.png";